var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Checkbox',{attrs:{"checked":_vm.copy,"disabled":_vm.disabled},on:{"input":function($event){return _vm.input($event)}}},[_vm._v("\n  "+_vm._s(_vm.$t('viewFilterTypeBoolean.selected'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }